module.exports = require('./helpers/bundle-url').getBundleURL('eO6Hv') + "logo.c5857b8b.svg";